module.exports = __webpack_public_path__ + "img/star.43e556b6.svg";